import React, { useState } from 'react';
import './KnowMoreBanner.scss';
import CallPopup from './tools/CallPopup';
import { useLocation, useNavigate } from 'react-router-dom';

const KnowMoreBanner = ({ contactSectionId }) => {
  const [isPopupOpen, setPopupOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  const isAgentVersion = location.pathname.includes('/agent');

  const scrollToContact = (event) => {
    event.preventDefault();
    if (isAgentVersion) {
      navigate('/agent/valuation');
    } else {
      const section = document.getElementById(contactSectionId);
      if (section) {
        section.scrollIntoView({ behavior: 'smooth' });
      }
    }
  };

  const togglePopup = () => {
    setPopupOpen(!isPopupOpen);

    const cookieBanner = document.getElementById('CookieNewDialog');

    if (!isPopupOpen) {
      if (cookieBanner) {
        cookieBanner.style.opacity = '0';
        cookieBanner.style.pointerEvents = 'none';
      }
    } else {
      if (cookieBanner) {
        cookieBanner.style.opacity = '1';
        cookieBanner.style.pointerEvents = 'auto';
      }
    }
  };

  return (
    <div className="know-more-banner-unique">
      <h3 className="know-more-banner-title">How Much Is Your House Worth?</h3>
      <p className="know-more-banner-text">
        {isAgentVersion
          ? 'Contact one of our experienced estate agents to book a FREE property valuation and find out how much your house is worth.'
          : 'With our FREE online property valuation tool, you can easily check the value of your house or contact one of our experienced estate agents for an in-depth home appraisal.'}
      </p>
      <div className="know-more-banner-button-container">
        <button className="know-more-banner-btn" onClick={togglePopup}>
          Call Now
        </button>
        <button className="know-more-banner-btn" onClick={scrollToContact}>
          {isAgentVersion ? 'Free Valuation' : 'Book Valuation'}
        </button>
      </div>

      <CallPopup isPopupOpen={isPopupOpen} togglePopup={togglePopup} />
    </div>
  );
};

export default KnowMoreBanner;
